import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';


interface Props {
  onClick?: () => void;
  opt: any;
  className?: string;
  current?: number
}

// interface State {
//   current: number;
// }

export default class MenuSale extends React.Component<any> {

 	// public state: State = {
  //   current: this.props.defaultIndex || 0
  // };

  private tabFun = (url) => {
    history.replace(url)
  }

	public render() {
    	const { opt, className, current } = this.props;
    	return (
        <div className={cx(styles.menu, className)}>
          {opt.map((option, index) => {
            return (
              <div 
                className={cx(styles.tab_lis,index == current && styles.active)}
                onClick={this.tabFun.bind(this,option.url)}
                key={index}
              >
                {index == current? (
                   <img
                      className={styles.ico}
                      src={option.selectIco}
                    />
                ):(
                  <img
                    className={styles.ico}
                    src={option.ico}
                  />
                )}
                
                <div className={styles.tab_txt}>{option.title}</div>
              </div>
            )
          })}
        </div>
    	)
  }
}
